var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "body" },
          [
            _c("input-data-calendario", {
              attrs: {
                "passeio-id": _vm.passeioId,
                "initial-available-days": _vm.initialAvailableDays,
              },
              model: {
                value: _vm.selectedDate,
                callback: function ($$v) {
                  _vm.selectedDate = $$v
                },
                expression: "selectedDate",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loadingAvailability,
                    expression: "loadingAvailability",
                  },
                ],
                staticStyle: { "text-align": "center", "margin-top": "10px" },
              },
              [_c("i", { staticClass: "fa-regular fa-hourglass" })]
            ),
            _vm._v(" "),
            _c("input-horario", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loadingAvailability && _vm.selectedDate,
                  expression: "!loadingAvailability && selectedDate",
                },
              ],
              staticStyle: { "margin-top": "8px" },
              attrs: {
                horarios: _vm.horarios,
                "selected-quantities": _vm.selectedAgeRanges,
                "primary-color": _vm.corPrimaria,
                "show-remaining-vacancies": _vm.showRemainingVacancies,
                "passeio-tipo": _vm.tipoPasseio,
                "titulo-atividade": _vm.tituloAtividade,
                "genero-titulo-atividade": _vm.generoTituloAtividade,
              },
              model: {
                value: _vm.selectedAvailability,
                callback: function ($$v) {
                  _vm.selectedAvailability = $$v
                },
                expression: "selectedAvailability",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("input-tickets", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loadingAvailability && _vm.selectedDate,
              expression: "!loadingAvailability && selectedDate",
            },
          ],
          key: _vm.selectedDate,
          attrs: {
            options: _vm.ageRanges,
            "selected-date": _vm.selectedDate,
            "primary-color": _vm.corPrimaria,
            min: _vm.quantidadeMinVenda,
            max: _vm.quantidadeMaxVenda,
            "nome-item": _vm.$props.nomeItem,
            moeda: _vm.$props.moeda,
            available: _vm.horarios,
            "selected-availability": _vm.selectedAvailability,
            "tipo-passeio": _vm.$props.tipoPasseio,
            "cobrar-taxa": _vm.cobrarTaxa,
            taxa: _vm.taxa,
          },
          on: {
            "on-options-open-state-change": _vm.ageRangeOpened,
            "on-complience-state-change": _vm.complienceChange,
          },
          model: {
            value: _vm.selectedAgeRanges,
            callback: function ($$v) {
              _vm.selectedAgeRanges = $$v
            },
            expression: "selectedAgeRanges",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "body" },
          [
            _c("input-opcionais", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.nPessoas > 0 && _vm.openOpcionais,
                  expression: "nPessoas > 0 && openOpcionais",
                },
              ],
              attrs: {
                "selected-date": _vm.selectedDate,
                max: _vm.nPessoas,
                "primary-color": _vm.corPrimaria,
                "mobile-mode": false,
                "passeio-id": _vm.passeioId,
                moeda: _vm.$props.moeda,
              },
              on: {
                "optionals-availability-change": (av) =>
                  (_vm.hasOptionalsAvailable = av),
              },
              model: {
                value: _vm.selectedOptionals,
                callback: function ($$v) {
                  _vm.selectedOptionals = $$v
                },
                expression: "selectedOptionals",
              },
            }),
            _vm._v(" "),
            _c("submit-button", {
              staticStyle: { "margin-top": "10px" },
              attrs: { disabled: !_vm.isReady, "is-loading": _vm.isSubmitting },
              on: { click: _vm.submit },
            }),
            _vm._v(" "),
            _vm.$props.hasPaymentPartial
              ? _c("alerta-pagamento-parcial", {
                  attrs: {
                    "preco-parcial-label": _vm.$props.precoParcial,
                    "porcentagem-parcial": _vm.$props.porcentagemParcial,
                    total: _vm.subtotal + _vm.totalOpcionais,
                    moeda: _vm.$props.moeda,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.openOpcionais
              ? _c("resumo-compra", {
                  staticStyle: { "margin-top": "25px" },
                  attrs: {
                    total: _vm.totalSemDesconto,
                    opcionais: _vm.totalOpcionais,
                    desconto: 0,
                    moeda: _vm.$props.moeda,
                    "cobrar-taxa": _vm.cobrarTaxa,
                    taxa: _vm.totalTaxa,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }, [
      _c(
        "strong",
        {
          key: "subtotal_" + _vm.subtotal,
          staticStyle: { visibility: "hidden", display: "block" },
          style: { visibility: _vm.isMounted ? "visible" : "hidden" },
        },
        [
          _vm._v(
            "\n      Subtotal: " +
              _vm._s(
                _vm.formatMoney(
                  _vm.subtotal + _vm.totalOpcionais + _vm.totalTaxa
                )
              ) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.$props.discountByPaymentMethod
        ? _c(
            "span",
            {
              key: "totalDesconto_" + _vm.totalDesconto,
              staticStyle: { display: "none", color: "#2fb97a" },
              style: {
                display:
                  _vm.isMounted &&
                  _vm.totalDesconto > 0 &&
                  _vm.totalDesconto < _vm.subtotal
                    ? "block"
                    : "none",
              },
            },
            [
              _vm._v(
                "\n      Pagando no " +
                  _vm._s(_vm.discountPaymentMethodsLabel || "Pix") +
                  ": " +
                  _vm._s(
                    _vm.formatMoney(
                      _vm.totalDesconto +
                        _vm.totalOpcionais +
                        _vm.totalTaxaDesconto
                    )
                  ) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-evento" }, [
      _c("span", [_vm._v("Ingressos")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }